import { Box, Switch, Typography } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#1890ff",
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#1890ff",
    },
  },
  securityBox: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
    alignItems: "center",
    border: "1px solid #D9D9D9",
    borderRadius: "4px",
    padding: "8px",
    // paddingTop: "8px",
    // paddingBottom: "8px",
    marginBottom: "16px",
  },
}));
export default function LoginSecurity({ user }) {
  const classes = useStyles();
  return (
    <div>
      <Typography
        style={{
          fontSize: "16px",
          fontWeight: 600,
          // marginTop: "1em",
          marginBottom: "1em",
        }}
      >
        Login Security
      </Typography>
      <Box className={classes.securityBox}>
        <Box>
          <Typography style={{ fontWeight: 500, fontSize: "14px" }}>
            2-Step Authenticated
          </Typography>
          <Typography
            variant="caption"
            style={{ fontSize: "12px", fontWeight: 300 }}
          >
            Authenticate the persion using code sent to the persons device
            (phone number in this case).
          </Typography>
        </Box>
        <Switch
          classes={{ root: classes.root }}
          disabled
          checked={user?.two_step_authentication}
        ></Switch>
      </Box>
      <Box className={classes.securityBox}>
        <Box>
          <Typography style={{ fontWeight: 500, fontSize: "14px" }}>
            Cannot Edit Phone Number
          </Typography>
          <Typography
            variant="caption"
            style={{ fontSize: "12px", fontWeight: 300 }}
          >
            Don't allow the user to edit their phone number. This requires you
            to enter the phone number.
          </Typography>
        </Box>
        <Switch
          classes={{ root: classes.root }}
          disabled
          checked={typeof user?.edit_phone_number === 'boolean' ? !user?.edit_phone_number : false}
        ></Switch>
      </Box>
      {localStorage.getItem('collabType') !== 'CMO' && <Box className={classes.securityBox}>
        <Box>
          <Typography style={{ fontWeight: 500, fontSize: "14px" }}>
            Ping Sign-in Enabled
          </Typography>
          <Typography
            variant="caption"
            style={{ fontSize: "12px", fontWeight: 300 }}
          >
            Enable this option to use Ping credentials to verify the
            person.
          </Typography>
        </Box>
        <Switch
          classes={{ root: classes.root }}
          disabled
          checked={user?.azure_AD_signin}
        ></Switch>
      </Box>}
    </div>
  );
}
